<button *appRole="['Usuarios.Eliminar']" mat-stroked-button color="warn" class="float-right " (click)="openDialog()">
    <mat-icon>delete</mat-icon>Eliminar
</button>
